const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { Promise } = require('es6-promise');
const { APIGet } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');

const resetEcommerceKey = () => ({
    type: actionTypes.ECOMMERCE_KEY_RESET
});

const setExpired = () => ({
    type: actionTypes.SET_ECOMMERCE_KEY_EXPIRED
});

const requestEcommerceKey = () => ({
    type: actionTypes.FETCH_ECOMMERCE_KEY_REQUEST
});

const requestEcommerceSuccess = data => ({
    type: actionTypes.FETCH_ECOMMERCE_KEY_SUCCESS,
    payload: {
        challenge: data.challenge
    }
});

const requestEcommerceKeyFailure = error => ({
    type: actionTypes.FETCH_ECOMMERCE_KEY_FAILURE,
    payload: {
        error
    }
});

const requestKey = () => (dispatch, getState) => {
    const callback = (dispatchCallback, getStateCallback, dataToken) => {

        const requestData = {
            header: {
                dataToken,
                version: 2,
            },
        };


        dispatch(requestEcommerceKey());
        APIGet(dispatchCallback, apiURLBuilder.getURL('ecommerceKeyRequest'), requestData).then(
            response => dispatchCallback(requestEcommerceSuccess(response)),
            response => dispatchCallback(requestEcommerceKeyFailure(response))
        );
    }

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

module.exports = {
    resetEcommerceKey,
    setExpired,
    requestKey
}
